import { useState } from "react";
import { useExpertCommunityCounters } from "../../../../hooks/partners/useExpertCommunityCounters"
import { useMastermindPartner } from "../../../../hooks/partners/useMastermindPartner";
import { useForumPartner } from "../../../../hooks/partners/useForumPartner";
import { DatatableComponent } from "../../../../helpers/DatatableComponent";
import { defaultProfileImage } from "../../../../utils/constants";
import { capitalLetter } from "../../../../utils/inputValidations";

type Props = {
    partner: any;
}


export const CommunityExpertTab = ({ partner }: Props) => {
    
    const { counters } = useExpertCommunityCounters(partner.id);
    const [mastermindPage, setMastermindPage] = useState(1);
    const [forumPage, setForumPage] = useState(1);

    const { list: mastmind, loading: loadMastermind, totalPages: mastermindTotalPages } = useMastermindPartner(partner.id, mastermindPage);
    const { list: forum, loading: loadForum, totalPages: forumTotalPages } = useForumPartner(partner.id, forumPage);

    return (
        <div className="w-100 d-flex flex-column" style={{ gap: 'var(--External-Grouping, 40px)' }}>
            <div className="expertise-tags-wrapper">
                <div className="tag">
                    <span className="label">Total Request</span>
                    <span className="value">{counters.totalRequests}</span>
                </div>
                <div className="tag">
                    <span className="label">Declined</span>
                    <span className="value">{counters.declined}</span>
                </div>
                <div className="tag">
                    <span className="label">Unanswered</span>
                    <span className="value">{counters.unanswered}</span>
                </div>
                <div className="tag">
                    <span className="label">Accepted</span>
                    <span className="value">{counters.accepted}</span>
                </div>
                <div className="tag">
                    <span className="label">Rating</span>
                    <span className="value">-/10</span>
                </div>
            </div>

            <div className="d-flex w-100 flex-column"> 
                <span className="expert-post-subtitle">MASTERMIND CIRCLE</span>
                <DatatableComponent 
                    columns={[
                        {
                            key: 'id',
                            label: 'ID',
                            getValue: (row) => <>#{row.id}</>
                        },
                        {
                            key: 'title',
                            label: 'TITLE'
                        },
                        {
                            key: '',
                            label: 'OWNED BY',
                            getValue: (row) => <div className="author-post">
                                <img src={row.authorAvatar ?? defaultProfileImage}/> 
                                <span>{row.authorName}</span> 
                            </div>
                        },
                        {
                            key: '',
                            label: 'TAGS',
                            getValue: (row) => <>{(row.tags as string[]).join(", ")}</> 
                        },
                        {
                            key: '',
                            label: 'STATUS',
                            getValue: (row) => <>{capitalLetter(row.status)}</>
                        }
                    ]}
                    data={mastmind}
                    currentPage={mastermindPage}
                    totalPages={mastermindTotalPages}
                    textNoWrap
                    isLoading={loadMastermind}
                    tableClassName="partner-post-table"
                />
            </div>
            <div className="d-flex w-100 flex-column"> 
                <span className="expert-post-subtitle">FORUM</span>
                <DatatableComponent 
                    columns={[
                        {
                            key: 'id',
                            label: 'ID',
                            getValue: (row) => <>#{row.id}</>
                        },
                        {
                            key: 'title',
                            label: 'TITLE'
                        },
                        {
                            key: '',
                            label: 'OWNED BY',
                            getValue: (row) => <div className="author-post">
                                <img src={row.authorAvatar ?? defaultProfileImage}/> 
                                <span>{row.authorName}</span> 
                            </div>
                        },
                        {
                            key: '',
                            label: 'TAGS',
                            getValue: (row) => <>{(row.tags as string[]).join(", ")}</> 
                        },
                        {
                            key: '',
                            label: 'STATUS',
                            getValue: (row) => <>{capitalLetter(row.status)}</>
                        }
                    ]}
                    data={forum}
                    currentPage={forumPage}
                    totalPages={forumTotalPages}
                    textNoWrap
                    isLoading={loadForum}
                    tableClassName="partner-post-table"
                />
            </div>
        </div>
    )
}